import { AttributesMixin, define, Model, type } from "@type-r/models";
import { DropdownFilter } from "../../components/search-bar/filters/dropdown-filter";
import { MultiSelectChipsAsyncFilter } from "../../components/search-bar/filters/multiselect-chips-async-filter";
import { TextFilter } from "../../components/search-bar/filters/text-filter";
import { PagingSortingBaseRequest } from "../../import-templates/models/get-filtered-import-templates-request";

const defaultSort = {
    attr: "createdOn",
    asc: false
};
export interface GetConnectionsRequest extends PagingSortingBaseRequest {
    companyIds: any;
    flowDirection: number;
    channelType: number;
    isActive?: boolean;
    connectionId: number;
    sortBy: string;
}

export const SortingTemplate = {
    createdOn: 'Created On',
    updatedOn: 'Updated On'
}

export interface ConnectionsFilters extends AttributesMixin<typeof ConnectionsFilters> { }

@define
export class ConnectionsFilters extends Model {
    static attributes = {
        filterAll: '',
        company: MultiSelectChipsAsyncFilter,
        flowDirection: DropdownFilter,
        channel: DropdownFilter,
        connectionId: type(TextFilter),
        sortBy: type(defaultSort)
    }

    reset() {
        this.filterAll = '';
        this.company.$.selected.set([] as any);
        this.flowDirection.$.selected.set([] as any);
        this.channel.$.selected.set([] as any);
        this.connectionId.$.value.set('');
    }

}
